<img src="../../../../assets/noun-mobile-rotate-817324-FFFFFF.png" class="hide-on-desktop phone-flip" />
<div class="table-container">
    <table>
        <thead>
            <tr>
                <th></th>
                <th style="text-align: left;">
                    Player
                </th>
                <th class="center">Score</th>
                <th class="center hide-on-mobile">{{ isHybridScramble ? 'Courses Complete' : 'Rounds Counted' }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let l of leaderboard; let i = index">
                <tr [class.no-score-row]="!hasScore(l)" [class.unofficial-row]="hasScore(l) && !isOfficialScore(l)">
                    <td>{{ isOfficialScore(l) ? (getRank(i)).toString() : '' }}</td>
                    <td style="width: 50%; text-align: left;">
                        <button
                            type="button"
                            class="player-link"
                            *ngIf="canShowBreakdown(l); else plainName"
                            (click)="openBreakdown(l, $event)">
                            {{ playerLabel(l) }}
                        </button>
                        <ng-template #plainName>
                            {{ playerLabel(l) }}
                        </ng-template>
                        <p class="hide-on-desktop" *ngIf="isHybridScramble && hasScore(l)">
                            <span class="status-badge" [class.unofficial]="!isOfficialScore(l)" [class.official]="isOfficialScore(l)">{{ courseProgress(l) }}</span>
                        </p>
                        <p *ngIf="isTeamEvent">
                            <span class="team-player-name">{{ l.teamPlayerNames }}</span>
                        </p>
                    </td>
                    <td class="center">
                        {{ formatScore(l) }}
                    </td>
                    <td class="center hide-on-mobile">
                        <ng-container *ngIf="isHybridScramble; else countedRounds">
                            <span class="status-badge" *ngIf="hasScore(l)" [class.unofficial]="!isOfficialScore(l)" [class.official]="isOfficialScore(l)">{{ courseProgress(l) }}</span>
                            <ng-container *ngIf="!hasScore(l)">-</ng-container>
                        </ng-container>
                        <ng-template #countedRounds>
                            {{ hasScore(l) ? l.roundsCounted : '-' }}
                        </ng-template>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>

<p class="leaderboard-note" *ngIf="isHybridScramble">
    A score stays unofficial until the minimum rounds are posted on every course. Unofficial scores are shown, but they are not ranked.
</p>

<div class="modal-overlay" *ngIf="breakdown" (click)="closeBreakdown()">
    <div class="modal-sheet breakdown-sheet" (click)="$event.stopPropagation()">
        <div class="modal-title">{{ breakdown.playerName }}</div>
        <p class="breakdown-help">
            Course score is the average of the best nets, shown as soon as a round is posted.
            It becomes official once the minimum rounds are posted on every course.
        </p>

        <div class="course-block" *ngFor="let course of breakdown.courses">
            <div class="course-heading">
                {{ course.courseName }}
                <span class="status-badge" [class.official]="course.isOfficial" [class.unofficial]="!course.isOfficial">
                    {{ course.isOfficial ? 'Official' : 'Unofficial' }}
                </span>
                <span class="course-meta">
                    Par {{ course.coursePar }} · {{ course.postedCount }} of {{ course.roundsToCount }} rounds posted
                </span>
            </div>

            <p class="course-empty" *ngIf="course.rounds.length === 0">No rounds posted yet.</p>

            <table class="breakdown-table" *ngIf="course.rounds.length > 0">
                <thead>
                    <tr>
                        <th>When</th>
                        <th>Partner</th>
                        <th>Gross</th>
                        <th>Net</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let round of course.rounds" [class.counted-row]="round.counted" [class.dropped-row]="!round.counted">
                        <td>{{ round.dateLabel }}</td>
                        <td>{{ round.partnerLabel }}</td>
                        <td>{{ round.grossScore }}</td>
                        <td>{{ round.netScore }}</td>
                        <td>
                            <span class="counted-badge" *ngIf="round.counted">Best</span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="course-math" *ngIf="course.roundedAvg !== null && course.scoreToPar !== null">
                Best nets {{ countedNetsLabel(course) }}
                → avg {{ course.roundedAvg }}
                → {{ course.roundedAvg }} − {{ course.coursePar }}
                = <strong>{{ formatScoreToPar(course.scoreToPar) }}</strong>
            </div>
        </div>

        <div class="event-total" *ngIf="breakdown.eventTotalToPar !== null">
            {{ breakdown.isOfficial ? 'Official' : 'Unofficial' }} event total:
            <strong>{{ formatScoreToPar(breakdown.eventTotalToPar) }}</strong>
        </div>

        <button type="button" class="breakdown-close" (click)="closeBreakdown()">Close</button>
    </div>
</div>
